import { Navigate } from "react-router";
import { LoadingState } from "@/components/states";
import { QueryError } from "@/features/dashboard/QueryError";
import { useMe } from "@/lib/me";
import { useTracks } from "@/features/dashboard/api";

/**
 * "/" sends you where your roles say. A supervisor with no track goes to the
 * review queue. A practitioner who already has a track goes to that track - onboarding is
 * for people with no track, and showing it to everyone on every sign-in was the bug.
 */
export function RootRedirect() {
  const me = useMe();
  const roles = me.data?.roles;
  const supervisorOnly = Boolean(roles?.supervisor && !roles.practitioner);
  // A supervisor with no practitioner role has no tracks of their own, so do not ask for them.
  const tracks = useTracks();
  const skipTracks = me.isPending || supervisorOnly;

  if (me.isPending) return <LoadingState rows={2} />;
  if (supervisorOnly) return <Navigate to="/supervise" replace />;
  if (!skipTracks && tracks.isPending) return <LoadingState rows={2} />;
  if (tracks.error) {
    return (
      <QueryError
        title="We couldn't load your tracks"
        error={tracks.error}
        onRetry={() => void tracks.refetch()}
      />
    );
  }

  // Active first: an archived track is read-only, so it is a poor place to land.
  const items = tracks.data?.items ?? [];
  const landing = items.find((track) => track.status === "active") ?? items[0];
  if (landing) return <Navigate to={`/t/${landing.id}`} replace />;
  return <Navigate to="/onboarding" replace />;
}
